import {StarFilled, StarOutlined} from '@ant-design/icons'
import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Toggle from '../../SidePanel/RightPanel/PropertiesControllerToggle.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Cm from '../CM/PropertiesControllerCm.jsx'
import Model from './ModelUc.mjs'
import ButtonExport from './PropertiesPaneButtonExport.jsx'
import ButtonExportReqConfirm from './PropertiesPaneButtonExportReqConfirm.jsx'
import ButtonImport from './PropertiesPaneButtonImport.jsx'
import ButtonPreview from './PropertiesPaneButtonPreview.jsx'
import SelectPriority from './PropertiesControllerSelectPriority.jsx'

const PropertiesPaneUc = (props) => (
    <ProductPropertiesPane
        buttons={
            <>
                {/*<ButtonDemo />*/}
                <ButtonPreview />
                <ButtonImport />
                <ButtonImport type='BDLOGIC'/>
                <ButtonExportReqConfirm />
                <ButtonExport />
            </>
        }

        controllers={
            <>
                <Cm />
                <Text prop="sfNo" />

                <Text
                    prop="sfName"

                    labelSuffix={
                        <Toggle
                            prop="ucStar"
                            color="#ff4d4f"
                            trueIcon={<StarFilled />}
                            falseIcon={<StarOutlined />}
                        />
                    }
                />

                <Text prop="reqNo" />
                <SelectPriority />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneUc
